import PropTypes from 'prop-types'
import React from 'react'
import { t } from 'src/lib/i18n-react'
import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'
import ProgressBar from 'src/ui/ProgressBar/ProgressBar'
import SingleStudyGoal from 'src/ui/StudyGoals/subcomponents/SingleStudyGoal/SingleStudyGoal'
import SingleStudyGoalProgress from 'src/ui/StudyGoals/subcomponents/SingleStudyGoalProgress/SingleStudyGoalProgress'


const WrapupCardStudyGoals = ({
  animateCompletion,
  weeklyGoals,
}) => {
  const weeklyCompleted = weeklyGoals?.completed
  const weeklyCompleteFraction = weeklyGoals?.completeFraction
  const weeklyGoal = weeklyGoals?.goal

  return weeklyGoals ? (
    <PageWrapupCard>
        <SingleStudyGoal
          title={t('Weekly Goal')}
          numericProgressSection={
            <SingleStudyGoalProgress
              completed={weeklyCompleted}
              goal={weeklyGoal}
              unit="minutes"
            />
          }
          progressBarSection={
            <ProgressBar
              size="thick"
              animateCompletion={animateCompletion}
              completeFraction={weeklyCompleteFraction}
              customWidth='100%'
            />
          }
        />
    </PageWrapupCard>
  ) : null
}

WrapupCardStudyGoals.propTypes = {
  animateCompletion: PropTypes.bool,
  weeklyGoals: PropTypes.object,
}

export default WrapupCardStudyGoals
